document.addEventListener("DOMContentLoaded", function () {

  const shelfBanner = document.querySelectorAll(".tarjeta-footer-content");

    shelfBanner.forEach((element) => {
        var larguraDaTela = window.innerWidth;
        if(larguraDaTela <= 600){
          $(`.${element.classList}`).slick({
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
          });
        }
    });
});


